import { render, staticRenderFns } from "./Opportunity.vue?vue&type=template&id=d3bc4c3c&scoped=true&"
import script from "./Opportunity.vue?vue&type=script&setup=true&lang=js&"
export * from "./Opportunity.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3bc4c3c",
  null
  
)

export default component.exports